<template>
  <div class="main">
    <c-panel title="Tipos de Tarefa" titleIcon="fas fa-tags">
      <!--
        FASE 4 / BLOCO AE — CI 16, 26, 29, 47, 51.

        "memorando, circular, comunicado, ofício, entre outros", cada um com sua regra de
        fluxo e seu identificador com prefixo, número e ano.

        Só a rede mantém estes tipos (decisão A5): eles padronizam o expediente de todas as
        escolas, e o `crud-simples` esconde os botões de escrita para os demais perfis — o
        backend recusa de qualquer forma.
      -->
      <crud-simples endpoint="api/tarefa-tipo" rotuloNovo="NOVO TIPO"
                    nomeSingular="tipo de tarefa" placeholderBusca="Pesquisar por nome"
                    :perfisEscrita="[4, 5]"
                    :campos="campos" :colunas="colunas"></crud-simples>
    </c-panel>
  </div>
</template>

<script>
import CrudSimples from '@/shared/crud-simples/crud-simples.vue'

export default {
  components: { CrudSimples, cPanel: () => import('@/shared/c-panel/c-panel.vue') },
  data: () => ({
    campos: [
      { chave: 'nome', label: 'Nome', obrigatorio: true, span: 12, max: 120 },
      { chave: 'prefixo', label: 'Prefixo (2 a 20 letras/números)', obrigatorio: true, span: 6, max: 20 },
      { chave: 'digitos_numero', label: 'Dígitos do número', tipo: 'number', span: 6, padrao: 4 },
      { chave: 'formato_identificador', label: 'Formato do identificador', span: 12, max: 80,
        padrao: '{prefixo}-{numero}/{ano}' },
      { chave: 'prazo_padrao_dias', label: 'Prazo padrão (dias)', tipo: 'number', span: 6 },
      { chave: 'permite_despacho', label: 'Aceita despacho', tipo: 'switch', span: 6, padrao: true },
      { chave: 'prazo_obrigatorio', label: 'Prazo obrigatório', tipo: 'switch', span: 6 },
      { chave: 'ativo', label: 'Ativo', tipo: 'switch', span: 6, padrao: true }
    ],
    colunas: [
      { chave: 'nome', label: 'Nome' },
      { chave: 'prefixo', label: 'Prefixo', largura: '110px' },
      { chave: 'formato_identificador', label: 'Identificador', largura: '200px', mobileOculto: true },
      { chave: 'permite_despacho', label: 'Despacho', largura: '110px', booleano: true, mobileOculto: true },
      { chave: 'prazo_obrigatorio', label: 'Prazo obrig.', largura: '120px', booleano: true, mobileOculto: true },
      { chave: 'ativo', label: 'Ativo', largura: '90px', booleano: true }
    ]
  })
}
</script>
